import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import cart from "../../assets/images/cartwhite.png"
import image from "../../assets/images/team-image.png"
import "antd/dist/antd.css";
import { Menu, Dropdown } from "antd";
import {createBrowserHistory} from 'history'
import { SearchOutlined } from '@ant-design/icons'

function NavSearch() {
  const [expand, setExpand] = useState(false);

  const history = createBrowserHistory({forceRefresh: true })

  const handleLogout = () => {
    localStorage.clear();
    history.push('/login-individual')
  }

  const handleExpand = () => {
    setExpand(!expand);
  };
  const menu = (
    <Menu onClick={handleExpand}>
      <Menu.Item key="1">
        <Link to="/user-dashboard">ACCOUNT</Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to="#">SETTINGS</Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to="#" onClick={() => handleLogout()}>LOGOUT</Link>
      </Menu.Item>
    </Menu>
  );
  return (
    <div>
      <div className="header__search">
        <form className="header__search__1 mr-3">
          <SearchOutlined style={{ color: '#939CA7', fontSize: '24px' }} />
          <input type="text" style={{ paddingLeft: '19px' }} placeholder="Search Drugs" id="" />
        </form>
        <Dropdown overlay={menu} className="mr-3">
          {/* <Button> */}
          <img src={image} style={{ width: '40px', height: '40px' }} alt="" />
          {/* </Button> */}
        </Dropdown>
        <img src={cart} style={{ width: '30px' }} alt="" className="header__search--cart-icon" />


      </div>

    </div>
  )
}

export default NavSearch